const paymentsUrls = {
  card_init: 'web-payment/init/card-payment/',
  card_accept: 'web-payment/accept/card-payment/',
  paypal_init: 'web-payment/init/pay-pal-payment/',
  paypal_accept: 'web-payment/accept/pay-pal-payment/',
  addons: 'web-payment/addons/',
  initUser: 'web-payment/init-user/',
  update_user_email: 'web-payment/change-email/'
}

export default (api) => ({
  card_init: (data) => api.post(paymentsUrls.card_init, data),
  card_accept: (data) => api.post(paymentsUrls.card_accept, data),
  paypal_init: (data) => api.post(paymentsUrls.paypal_init, data),
  paypal_accept: (data) => api.post(paymentsUrls.paypal_accept, data),
  addons: (data) => api.post(paymentsUrls.addons, data),
  init_user: (data) => api.post(paymentsUrls.initUser, data),
  update_user_email: (data) => api.post(paymentsUrls.update_user_email, data)
})
